import { ListItemIcon, ListItemText } from '@/components/Dropdown/MenuItems/components';
import { upgradeFreePlanModalOpen } from '@/components/Modals/UpgradeFreePlanModal';
import { useNavigateToAdvancedEditor } from '@/hooks/navigation';
import { useFreeVideos } from '@/hooks/useFreeVideos';
import EditDraft from '@/images/EditDraft.svg';
import { useAnalytics } from '@/services/analytics';
import { MixPanelEvent } from '@/utils/types';
import { itemIsProject, LibraryItem, LibraryItemStatus } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';
import { useSetRecoilState } from 'recoil';

interface Props {
    video: LibraryItem;
    closeMenu: () => void;
}

export const EditMenuItem = ({ video, closeMenu }: Props) => {
    const { navigateToAdvancedEditor } = useNavigateToAdvancedEditor();
    const isMigratedProject = video?.id?.startsWith('prj_tlk_') || video?.id?.startsWith('prj_clp_');
    const isDraft = video && itemIsProject(video) && !isMigratedProject && [LibraryItemStatus.Created].includes(video.status);
    const { outOfFreeVideos } = useFreeVideos();
    const setUpgradeFreePlanModalOpen = useSetRecoilState(upgradeFreePlanModalOpen);
    const mixpanel = useAnalytics();

    if (!isDraft) {
        return null;
    }

    const handleClick = async () => {
        if (outOfFreeVideos) {
            setUpgradeFreePlanModalOpen(true);
            return;
        }

        mixpanel?.track('edit-draft', { event: MixPanelEvent.CLICK, videoId: video.id });

        await navigateToAdvancedEditor({ projectId: video.id });
        closeMenu();
    };

    return (
        <MenuItem onClick={handleClick}>
            <ListItemIcon>
                <img src={EditDraft} />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
        </MenuItem>
    );
};
